var map = {
	"./index.js": "zOfn",
	"./produtividade.js": "/+VW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fGOA";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/produtividade nonrecursive \.js$
// module id = fGOA
// module chunks = 12